<template>
  <span class="text-lg font-bold">
    {{ group.label }}
  </span>

  <div class="flex flex-col gap-4 px-4">
    <question
      v-for="(question, index) in group.questions"
      :key="question.id"
      :question-object="question"
      @question-update="updateQuestion"
      :index="index"
    ></question>
  </div>
</template>


<script>

import Question from "./question";
import { reactive, toRef, watch } from "vue";

export default {
  name: "group",
  props: {
    groupObject: {
      type: Object,
      required: true,
    },
  },
  components: {
    Question,
  },
  setup(props, { emit }) {
    const group = reactive(toRef(props, "groupObject"));

    function updateQuestion(question) {
      const i = group.value.questions.findIndex(
        (_element) => _element.id === question.id
      );
      if (i > -1) {
        group.value.questions[i] = question;
      } else {
        group.value.questions.push(question);
      }
    }

    watch(
      () => group,
      (current, previous) => {
        emit("groupUpdate", current.value);
      },
      {
        deep: true,
      }
    );

    return {
      group,
      updateQuestion,
    };
  },
};
</script>

<style scoped></style>
